export default __webpack_public_path__ + "static/media/who it is for.c7695b93.webp";